import { styled } from "@mui/material/styles";

export const SpinnerContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  left: 0,
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 99999,
}));
